<template>
  <div>
    <loading-spinner v-if="loading" />
    <div v-else>
      <div v-if="results.length > 0" class="results d-flex flex-wrap align-items-end justify-content-around mt-3">
        <div v-for="result of results" :key="result.id" class="d-flex flex-column result-item" @click="useImage(result)">
          <img :src="imagePreviewUrl(result)" class="image-preview">
          <span class="use-this badge bg-secondary">{{ i18n.t('components.image_upload.use_this') }}</span>
          <span class="text-center">{{ result.user }}</span>
        </div>
      </div>
      <span v-else>{{ i18n.t('components.image_upload.no_results') }}</span>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/loading-spinner'

const PREVIEW_WIDTH = '200'

export default {
  components: { LoadingSpinner },

  props: {
    loading: {
      type: Boolean,
      required: true
    },

    results: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  emits: ['use-image'],

  methods: {
    imagePreviewUrl(imageResult) {
      const previewUrl = new URL(imageResult.urls.raw)
      const previewParams = new URLSearchParams('')
      previewParams.append('w', PREVIEW_WIDTH)
      previewParams.append('fit', 'clip')
      previewUrl.search = previewParams.toString()

      return previewUrl.toString()
    },

    useImage(imageResult) {
      this.$emit('use-image', imageResult.id)
    }
  }
}
</script>


<style lang="scss" scoped>
.results {
  gap: 30px 20px;
}

.result-item {
  position: relative;
  cursor: pointer;

  &:hover {
    .use-this {
      display: block;
    }
  }
}

.image-preview {
  width: 200px; // Depending on the image ratio, preview images from Unsplash are sometimes narrower than the requested width.
                // Use the full width to make the images large enough to be easily visible to users.
}

.use-this {
  width: 70%;
  position: absolute;
  bottom: 20px;
  left: 15%;
  display: none;
}

</style>
